module.exports = __webpack_public_path__ + "static/media/icon-menu-primary.31645967.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/miami/ui/icon-menu-primary.svg
// module id = 564
// module chunks = 0